export enum PipelineStageEnum {
  PROPOSAL_GENERATED = "Proposal Generated",
  PROPOSAL_PRESENTED = "Proposal Presented",
  DOCUMENTS_OUT = "Documents Out",
  SALE_COMPLETE = "Sale Complete",
  CONTRACT_SIGNED = "Contract Signed",
  PROJECT_INTAKE = "Project Intake",
  PROJECT_START = "Project Start",
  SITE_SURVEY_SCHEDULED = "Site Survey Scheduled",
  SITE_SURVEY_COMPLETED = "Site Survey Completed",
}

export enum SubscriptionStatusEnum {
  ACTIVE = "active",
  PAST_DUE = "past_due",
  CANCELED = "canceled",
}

export enum CompositionTierEnum {
  TIER_3_MENTORS = "tier3Mentors",
  TIER_2_SELLERS = "tier2Sellers",
  TIER_1_SETTERS = "tier1Setters",
  ENTERPRISES = "enterprises",
}

export enum RankUpRequirementStatusEnum {
  MET = "met",
  PENDING = "pending",
  NOT_APPLICABLE = "not_applicable",
}

export enum RankUpRequirementLabelEnum {
  PRV = "PRV",
  BRV = "BRV",
  QLS = "QLs",
}

export enum PipelineStageGroupEnum {
  PROPOSAL = "proposal",
  CONTRACT = "contract",
  SITE_SURVEY = "site_survey",
}

export enum SponseeStatusEnum {
  ACTIVE = "active",
  NEW = "new",
  WATCH = "watch",
}

export enum TeamActivityTypeEnum {
  CONTRACT = "contract",
  PROPOSAL = "proposal",
  LEAD = "lead",
  INSTALL = "install",
  RECRUIT = "recruit",
  RANK_UP = "rank_up",
}

export enum TeamActivityCategoryEnum {
  ALL = "all",
  SALES = "sales",
  RECRUITS = "recruits",
  RANK_UPS = "rank_ups",
}
